var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Group as GroupModel } from '@/models/Group';
import { RolesEnum } from '@/items/Roles';
let Audit = class Audit extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Group';
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ]);
    }
};
__decorate([
    Model('group', { default: () => new GroupModel() }),
    __metadata("design:type", typeof (_a = typeof GroupModel !== "undefined" && GroupModel) === "function" ? _a : Object)
], Audit.prototype, "group", void 0);
Audit = __decorate([
    Component({
        components: {
        //
        },
    })
], Audit);
export default Audit;
